import { useModalMeta } from "@/shared/atoms/useModal";
import { OrderV2 } from "@/shared/v2/queries/interfacesV2";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import Modal, { ModalProps } from "../Modal/Modal";
import Order from "../Order/Order";

const OrderProductsModal = ({ onExit, ...props }: ModalProps) => {
  const [meta] = useModalMeta();
  const order: OrderV2 = meta.order;
  const hidePrice = meta?.hidePrice ?? true;
  const { t } = useTranslation("");
  return (
    <Modal width={"58rem"} onExit={onExit} {...props}>
      <div className="my-[3rem]">
        <Order orders={order} hidePrice={hidePrice} isMapOrder />
        {order.order_information.remarks && (
          <div style={{ fontWeight: "900" }}>
            {t("remarkOffTheCustomer", {
              value: order.order_information.remarks,
            })}
          </div>
        )}
      </div>
      <Button onClick={() => onExit()}>{t("close")}</Button>
    </Modal>
  );
};

export default OrderProductsModal;
